import { useNavigate, useParams } from 'react-router-dom';
import { t } from 'i18next';
import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import { CardIcon, CardKpi } from '@/components/ui/card';
import { TableCell, TableHead, TableRow, TableUser, TableUserContent, TableUserTitle } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { PATHS } from '@/routes/paths';
import { isScheduledPublication } from '@/components/custom/schedule-publication-modal';

export function CourseModuleAboutCardBooklet({ booklet }) {
  const navigate = useNavigate();
  const { courseId, moduleId } = useParams();
  const isScheduled = isScheduledPublication(booklet?.['question-book']);

  return (
    <TableRow>
      <TableHead scope="row">
        <TableUser>
          <CardIcon className="p-2">
            <FiCheckCircle size={16} />
          </CardIcon>
          <TableUserContent>
            <TableUserTitle
              className="truncate text-base"
              title={booklet?.['question-book']?.title}
            >
              {booklet?.['question-book']?.title}
            </TableUserTitle>
          </TableUserContent>
        </TableUser>
      </TableHead>
      <TableCell className="w-[100px]">
        <CardKpi
          title={`${booklet?.['question-book']?.['question-count']} questões`}
          aria-label={`${booklet?.['question-book']?.['question-count']} questões`}
        >
          <FiCheckCircle /> {booklet?.['question-book']?.['question-count']}
        </CardKpi>
      </TableCell>
      <TableCell className="w-[112px]">
        {isScheduled && (
          <Badge
            variant="warning"
            size="xs"
          >
            Em breve
          </Badge>
        )}
        {!isScheduled && booklet?.['is-required'] === true && (
          <Badge
            variant="danger"
            size="xs"
          >
            Obrigatório
          </Badge>
        )}
      </TableCell>
      <TableCell className="w-[128px] text-right">
        <Button
          variant="outline"
          size="sm"
          disabled={isScheduled}
          onClick={() =>
            navigate(`/questions/apostilas/${booklet?.['question-book']?.id}`, {
              state: { returnTo: PATHS.COURSE.MODULE(courseId, moduleId, 'apostilas') }
            })
          }
        >
          {t('button.view')}
        </Button>
      </TableCell>
    </TableRow>
  );
}
